import { decorate, observable, action, toJS } from 'mobx';
import { startCase, toLower } from 'lodash';

import { encodeUuids } from '../../utils/parse-encode-uuids';

import { postScheduleAssemblyV2 } from '../../apis/six-api/v2/schedules';

import { routerStore } from '../RouterStore';
import { modalStore } from '../ModalStore';

export default class SchedulingFormStore {
  isLoading = false;
  isFailure = false;

  name = {
    value: '',
    count: 0,
  };
  phone = {
    value: '',
    count: 0,
  };
  complement = {
    value: '',
    count: 0,
  };
  referencePoint = {
    value: '',
    count: 0,
  };
  selectedSchedulingDate = {};

  setSelectedSchedulingDate = date => {
    this.selectedSchedulingDate = date;
  };

  handleChangeInput = (input, event) => {
    let text = event.target.value;

    if (input !== 'phone') {
      const regex = /[^a-zA-Z0-9À-ú\s]/g;

      if (regex.test(text)) {
        text = text.replace(regex, '');
      }
    }

    this[input].value = text;
    this[input].count = text.length;
  };

  handleConfirmSchedulingClick = async (schedules, customerName) => {
    const selectedDate = toJS(this.selectedSchedulingDate);
    const uuids = schedules.map(schedule => schedule.uuid);
    const integrationIds = schedules.map(schedule => schedule.integrationId);

    try {
      this.isFailure = false;
      this.isLoading = true;

      await postScheduleAssemblyV2(
        encodeUuids(uuids),
        this.buildPayload(integrationIds, selectedDate)
      );

      modalStore.closeModal();
      routerStore.push('/agendado-com-sucesso', {
        customer: { name: customerName },
        scheduledDate: selectedDate.date,
      });
    } catch (error) {
      this.isFailure = true;
    } finally {
      this.isLoading = false;
    }
  };

  buildNotes = (name, phone, complement, referencePoint) => {
    let notes = '';

    if (name) {
      notes += `Nome: ${startCase(toLower(name.trim()))}`;
    }

    if (phone) {
      notes += `  Cel: ${phone.trim()}`;
    }

    if (complement) {
      notes += `  Comp: ${startCase(toLower(complement.trim()))}`;
    }

    if (referencePoint) {
      notes += `  P. Refer: ${startCase(toLower(referencePoint.trim()))}`;
    }

    return notes.trim();
  };

  buildPayload = (integrationIds, selectedDate) => {
    // eslint-disable-next-line no-param-reassign
    delete selectedDate.selected;

    const payload = {
      ...selectedDate,
      integrationIds,
      notes: this.buildNotes(
        this.name.value,
        this.phone.value,
        this.complement.value,
        this.referencePoint.value
      ),
    };

    if (!payload.notes) {
      delete payload.notes;
    }

    return payload;
  };
}

decorate(SchedulingFormStore, {
  isLoading: observable,
  isFailure: observable,
  name: observable,
  phone: observable,
  complement: observable,
  referencePoint: observable,
  selectedSchedulingDate: observable,
  setSelectedSchedulingDate: action,
  handleChangeInput: action,
  handleConfirmSchedulingClick: action,
});

const schedulingFormStore = new SchedulingFormStore();

export { schedulingFormStore };
